<form #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta - Câmbio"
    [operationDate]="model.operationDate"
    [id]="model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <app-dados-fundo
    #portfolio
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [ticketType]="TicketTypeEnum.Exchange"
  >
  </app-dados-fundo>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-3">
          <label>Modalidade</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                name="modalidade"
                checked
                disabled
                type="radio"
                [value]="1"
              />
              <label class="form-check-label">À Vista</label>
            </div>
          </div>
        </div>
        <div class="col-3">
          <label for="termo">Tipo Operação</label>
          <ng-template for="termo" #validatedLabel>Tipo Operação</ng-template>
          <div>
            <div
              class="form-check form-check-inline"
              *ngFor="let item of PurchaseTypes; index as i"
            >
              <input
                required
                class="form-check-input"
                type="radio"
                id="TipoOperacao-{{ i }}-id"
                name="operationTypeId"
                [(ngModel)]="model.operationTypeId"
                [value]="item.id"
              />
              <!-- *ngIf="this.OperationFieldEmpty; else validatedLabel" style="color: #dc143c;" -->
              <label class="form-check-label" for="TipoOperacao-{{ i }}-id">
                {{ item.name }}
              </label>
              <ng-template
                class="form-check-label"
                for="TipoOperacao-{{ i }}-id"
                #validatedInput
                >{{ item.name }}
              </ng-template>
            </div>
          </div>
        </div>

        <div class="col-6" *ngIf="model.operationTypeId && !isSell()">
          <label>Cotação</label>
          <input
            type="text"
            class="form-control"
            data-cy="currencyQuotation"
            name="currencyQuotation"
            [(ngModel)]="model.currencyQuotation"
            [textMask]="{ mask: validator.unitPriceMask }"
            maxlength="19"
          />
        </div>
      </div>

      <div class="row mb-2" *ngIf="model.operationTypeId">
        <div class="col-6">
          <label *ngIf="!isSell()">Moeda de Compra</label>
          <label *ngIf="isSell()">Moeda de Venda</label>
          <input
            type="text"
            class="form-control"
            data-cy="currencyName"
            name="currencyName"
            [(ngModel)]="model.currencyName"
            maxlength="20"
            required
          />
        </div>
        <div class="col-6">
          <label *ngIf="!isSell()">Valor da Compra</label>
          <label *ngIf="isSell()">Valor de Venda</label>
          <input
            type="text"
            class="form-control"
            data-cy="operationValue"
            name="operationValue"
            [(ngModel)]="model.operationValue"
            [textMask]="{ mask: validator.unitPriceMask }"
            maxlength="17"
            required
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <label>Paridade de Avaliação PL</label>
          <input
            type="text"
            class="form-control"
            data-cy="parityPl"
            name="parityPl"
            [(ngModel)]="model.parityPl"
            maxlength="20"
            required
          />
        </div>
        <div class="col-6">
          <label>Paridade MTM</label>
          <input
            type="text"
            class="form-control"
            data-cy="parityMtm"
            name="parityMtm"
            [(ngModel)]="model.parityMtm"
            maxlength="20"
            required
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <label>Data de Liquidação</label>
          <input
            placeholder="Select date"
            #tradingDate
            type="date"
            class="form-control"
            name="settlementDate"
            data-cy="settlementDate"
            [(ngModel)]="model.settlementDate"
            required
          />
        </div>
        <div class="col-6">
          <label>Contraparte</label>
          <input
            type="text"
            class="form-control"
            data-cy="counterpartName"
            name="counterpartName"
            [(ngModel)]="model.counterpartName"
            maxlength="20"
            required
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <label>Praça de Negociação</label>
          <input
            type="text"
            class="form-control"
            data-cy="tradingPlace"
            name="tradingPlace"
            [(ngModel)]="model.tradingPlace"
            maxlength="20"
            required
          />
        </div>
        <div class="col-6">
          <label>Praça de Liquidação</label>
          <input
            type="text"
            class="form-control"
            data-cy="settlementPlace"
            name="settlementPlace"
            [(ngModel)]="model.settlementPlace"
            maxlength="20"
            required
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-3">
          <label>Data do Recurso</label>
          <input
            placeholder="Select date"
            #tradingDate
            type="date"
            class="form-control"
            name="appealDate"
            data-cy="appealDate"
            [(ngModel)]="model.appealDate"
            required
          />
        </div>
        <div class="col-3">
          <label>Data de Vencimento</label>
          <input
            placeholder="Select date"
            #tradingDate
            type="date"
            class="form-control"
            name="expirationDate"
            data-cy="expirationDate"
            [(ngModel)]="model.expirationDate"
            required
          />
        </div>
        <div class="col-3">
          <label>Data de Liquidação Venda Contrato</label>
          <input
            placeholder="Select date"
            #tradingDate
            type="date"
            class="form-control"
            name="contractSaleSettlementDate"
            data-cy="contractSaleSettlementDate"
            [(ngModel)]="model.contractSaleSettlementDate"
          />
        </div>
        <div class="col-3">
          <label>Quantidade de Moeda </label>
          <input
            type="text"
            class="form-control"
            data-cy="currencyAmount"
            name="currencyAmount"
            [(ngModel)]="model.currencyAmount"
            maxlength="20"
          />
        </div>
      </div>
    </div>
  </div>

  <br />

  <app-annotation #annotation [annotation]="model.annotations"></app-annotation>

  <div class="actions" *ngIf="canEdit()">
    <input
      type="button"
      value="Salvar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
      data-cy="submit"
    />
    <input
      type="button"
      value="Encaminhar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
      data-cy="forward"
    />
    <input
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      [disabled]="!canCancel()"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
      data-cy="cancel"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      value="Aprovar"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
      data-cy="approve"
    />
    <input
      type="button"
      value="Reprovar"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
      data-cy="reject"
    />
  </div>

  <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      value="Duplicar"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
      data-cy="duplicate"
    />
  </div>
</form>

<app-workflow-history
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
